// removed by extract-text-webpack-plugin
module.exports = {"wrapfeatured":"_1ZroStP2qvcHL7noPS0W7g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/FeaturedEvents/style.css
// module id = 268
// module chunks = 42